module.exports = __webpack_public_path__ + "img/projects4-icon.4d3b1921.png";